import React from 'react';
import { maskName } from '../../../utils/utility';

interface MaskedNameWithToggleProps {
  patientName: string;
  showFullName: boolean;
}

// Add explicit return type for the functional component
const MaskedNameWithToggle: React.FC<MaskedNameWithToggleProps> = ({
  patientName,
  showFullName,
}: MaskedNameWithToggleProps): JSX.Element => {
  return (
    <span>
      {showFullName ? patientName : `${maskName(patientName)}`}
    </span>
  );
};

export default MaskedNameWithToggle;
